import { getOrderStatusColorName } from './getOrderStatusColorName';
export function getColorHexByPortionState(portionStateId, theme) {
    const colorName = getOrderStatusColorName(portionStateId);
    const paletteId = colorName === 'default' ? 'grey' : colorName;
    return theme.palette[paletteId].main;
}
